/**
 * Built key by key in each route file, so tsc checks every key against the route's `validateSearch` and this type.
 * A key both routes declare is required, so a route that leaves it out fails tsc; the optional two are the project's.
 */
export type BomDetailsQueryParams = {
    currentParentAssemblyId?: string;
    designItemId: string[] | undefined;
    filters: string | undefined;
    bomTab: BomTab | undefined;
    dashboardFilters: string | undefined;
    search: string | undefined;
    onlyShowItemsWithManufacturingWarnings?: boolean;
};

/** The route's query-param writer as the BOM details components take it, with only the keys they write. */
export type BomDetailsSearchChange = (patch: { filters?: string; designItemId?: string[]; bomTab?: BomTab }) => void;

/**
 * `?designItemId` for a BOM line: returns the first of its design items, from which `findSelectedModule` finds the line
 * A line has one design item per designator, so all of them can exceed the URL's 8 KB query param limit
 */
export function bomLineDesignItemId(designItemIds: readonly string[]): string[] | undefined {
    return designItemIds.length > 0 ? designItemIds.slice(0, 1) : undefined;
}

/** The tabs of a BOM item's form, which `?bomTab` names. */
export const bomTabs = ['selectedParts', 'manufacturingData'] as const;

export type BomTab = (typeof bomTabs)[number];
